import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Line from '../../../svg/Line/Line.js';
import { BAR_SCALE_CATEGORY_KEY, BAR_SCALE_COMPONENT_KEY } from '../BarScale.meta.js';

export default InjectedStyledComponent(Line, BAR_SCALE_CATEGORY_KEY, BAR_SCALE_COMPONENT_KEY, ['zeroAxis']);
